var contactInfo = function() {
  return function(referralLead) {
    var info = [referralLead.sent_to_email, referralLead.sent_to_phone];
    return _.compact(info).join(', ');
  };
};

contactInfo.$inject = [];

tiz.filter('referralLeadContactInfo', contactInfo);

var leadStatus = function() {
  return function(referralLead) {
    var statusKey = {
      sent: 'Sent',
      opened: 'Delivered',
      signed_up: 'Signed up',
      placed_first_order: 'First order placed!'
    };
    return _.get(statusKey, referralLead.state, 'Sending');
  };
};

leadStatus.$inject = [];

tiz.filter('referralLeadStatus', leadStatus);

var sentAt = function(fromNowFilter) {
  return function(referralLead) {
    if (referralLead.sent_at) {
      return referralLead.sent_at ? fromNowFilter(referralLead.sent_at) : 'Today';
    } else {
      return referralLead.signed_up_at ? fromNowFilter(referralLead.signed_up_at) : 'Today';
    }
  };
};

sentAt.$inject = ['fromNowFilter'];

tiz.filter('referralLeadSentAt', sentAt);
